module.exports = __webpack_public_path__ + "static/media/RahbarTravel.cafa2f6e.png";